// extracted by mini-css-extract-plugin
export default {"container":"q1neHP","isCenterAlignment":"oDE7UV","title":"Fv5w0u","isRightAlignment":"LpUSfe"};